import Box from "@mui/material/Box";
import React, {useEffect, useState} from "react";
import {Tooltip} from "@mui/material"


export default function AgentIcon(props: {agent_name: string, sx? :any}){
    const size = props.sx?.width || props.sx?.height || 40;
    const [src, setSrc] = useState(
        `https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${size},w_${size}/v1/valAssets/${props.agent_name}.png`
    );

    const handleImageError = () => {
        setSrc(`https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${size},w_${size}/v1/teamsLogo/Boa.png`);
    };

    useEffect(() => {
        setSrc(`https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${size},w_${size}/v1/valAssets/${props.agent_name}.png`);
    }, [props.agent_name, size]);

    return <Tooltip title={props.agent_name} followCursor={true}>
        <Box
            component={"img"}
            src={src}
            onError={() => handleImageError()}
            sx={{
                width: size,
                height: size,
                minWidth: size,
                minHeight: size,
                ...props.sx
            }}
        />
    </Tooltip>
}
